import { useEffect } from 'react';
import { ApiaUtil } from '../../../objects';

/**
 * Contorla la lógica encargada de cerrar el modal al presionar la tecla escape.
 */
export function useEscapeKey({
  closeHandler,
  id,
  isOpenInner,
  shouldCloseOnEsc,
}: {
  id: string;
  closeHandler: () => void;
  isOpenInner: boolean;
  shouldCloseOnEsc?: boolean;
}) {
  useEffect(() => {
    function handleEscape(event: KeyboardEvent) {
      if (event.code !== 'Escape') return;

      const notifications = [
        ...(document.querySelectorAll(
          '.notificationsFloatingList .notification',
        ) ?? []),
      ];
      if (notifications.length) {
        ApiaUtil.instance.notifications.closeAll();
        return;
      }

      const tooltips = [
        ...(document.querySelectorAll('.tooltip__wrapper') ?? []),
      ];
      if (tooltips.length) {
        return;
      }

      const overlays = [
        ...document.querySelectorAll('.overlay, .window__modal'),
      ];

      const modal = (event.target as HTMLElement).closest(`#modal__${id}`);
      if (modal) {
        /**
         * Funcionamiento para el WindowModal
         */
        event.preventDefault();
        event.stopPropagation();

        closeHandler();
      } else if (
        overlays.length > 0 &&
        (overlays[overlays.length - 1]?.id === id ||
          overlays[overlays.length - 1]?.id === `modal__${id}`)
      ) {
        /**
         * Legacy, para el StaticModal
         */
        event.preventDefault();
        event.stopPropagation();

        closeHandler();
      }
    }
    if (isOpenInner && shouldCloseOnEsc)
      document.addEventListener('keydown', handleEscape, false);
    return () => {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, [shouldCloseOnEsc, isOpenInner, closeHandler, id]);
}
